import * as rights from './rights';
import { APP_CONSTANTS } from './constants';
import { SETTINGS } from './settings';
import {
     STATUSES, REPORT_TYPES, DOSSIER_TYPES, ACTIVITYSTATUSES
} from './enums';
import managementApiClient from './managementApiClient';
import apiClient from './apiClient';
import wfApiClient from './wfApiClient';
import getLabel from './getLabel';
import currentUserHasRights from './currentUserHasRights';
import RendererBoolean from './RendererBoolean';
import RendererStatus from './RendererStatus';
import JsonDateExtensions from './JsonDateExtensions';
import preventDefaultHandlers from './preventDefaultHandlers';


export default {
     rights, APP_CONSTANTS, SETTINGS, managementApiClient, apiClient, wfApiClient, currentUserHasRights, preventDefaultHandlers, 
     RendererBoolean, RendererStatus,
     JsonDateExtensions, getLabel, STATUSES, REPORT_TYPES, DOSSIER_TYPES, ACTIVITYSTATUSES
};